import { toggleClasses } from '../functions.js';
import { menuWhiteout } from '../functions.js';
import { getSiblings } from '../functions.js';

const mobBurger = document.getElementById('mobBurger');
const header = document.getElementById('header');

/**
 * Show and hide entire menu on mobile
 */
mobBurger.addEventListener('click', function (e) {

  //toggle active class
  mobBurger.classList.toggle('active');

  toggleClasses('.mobMenuWrap', 'hidden block');

});

/**
 * Show and hide sub-menus on mobile
 */
//get all menu items with child menus
const parents = document.querySelectorAll('.menu-item-has-children');

function menuParentDisplay(menuItem) {
  menuItem.classList.toggle('active');

  //get submenu
  let submenu = menuItem.querySelector('.sub-menu');

  //check if submenu is hidden
  if (submenu.classList.contains('hidden')) {
    submenu.classList.remove('hidden');
    submenu.classList.add('block');
  } else {
    submenu.classList.remove('block');
    submenu.classList.add('hidden');
  }
}

parents.forEach(function (menuItem) {
  menuItem.addEventListener('click', function (e) {
    e.stopPropagation();

    menuParentDisplay(menuItem);

   let siblings = getSiblings(menuItem);

    siblings.forEach(function (sib) {
      if(sib.classList.contains('active')) {
        menuParentDisplay(sib);
      }
    });
  });
});

/**
 * Reduce size of menu when scrolled past 300px
 */

const breadcrumbs = document.getElementById('breadcrumbs');

function scrolledEffects() {
  header.classList.remove('whiteOut', '1024:bg-transparent');
  header.classList.remove('1024:pb-32', '1024:shadow-none');
  header.classList.add( '1024:pb-16', '1024:bg-white');
  document.getElementById('headerContact').classList.add('hidden');

  document.querySelector('.logo').style.cssText = 'width: 160px!important;';

  if(breadcrumbs) {
    breadcrumbs.classList.remove('1024:block');
  }
}


var scrollLimit = 50;

if (window.scrollY >= scrollLimit) {
  scrolledEffects();
}

window.onscroll = function() {
  if (window.scrollY >= scrollLimit) {
    scrolledEffects();
    parents.forEach(function (menuItem) {
      menuItem.classList.remove('active');

      //get submenu
      let submenu = menuItem.querySelector('.sub-menu');

      //check if submenu is hidden
      if (submenu.classList.contains('block')) {
        submenu.classList.remove('block');
        submenu.classList.add('hidden');
      }
    });
  }
  if (window.scrollY < scrollLimit) {
    menuWhiteout();
    header.classList.add('1024:pb-32', '1024:shadow-none', '1024:bg-transparent');
    header.classList.remove('1024:shadow', '1024:pb-16', '1024:bg-white');
    document.getElementById('headerContact').classList.remove('hidden');
    document.querySelector('.logo').style.cssText = '';
    if(breadcrumbs) {
      breadcrumbs.classList.add('1024:block');
    }
  }
};
